export default {
    //baseURL:'https://viivapi.trigma.ai/',
    baseURL:'https://uat-mmm-api.trigma.ai/',   
    appname:'Client Admin 1',
    appid:4,
    //PARAM_GLOBAL_LOGIN:"https://viiv.trigma.ai/#/",
    //PARAM_GLOBAL_HOME:"https://viiv.trigma.ai/#/extraauth?user_id=",
    
    //PARAM_GLOBAL_LOGIN:"https://dev-mmm.trigma.ai/#/",
    //PARAM_GLOBAL_HOME:"https://dev-mmm.trigma.ai/#/extraauth?user_id=",

    PARAM_GLOBAL_LOGIN: "https://uat-mmm.trigma.ai/#/",
    PARAM_GLOBAL_HOME: "https://uat-mmm.trigma.ai/#/extraauth?user_id=",
    getmacaddress(){
        return '10.2.2.24';
    }
}